<template>
    <div class="Header">
        <div
            :class="[
                'Header__bar',
                showBottomBar && 'Header__bar--top'
            ]"
        >
            <!-- @slot Header text -->
            <slot name="header">
                <h3 :class="statusBuilder('Header__header', status)">
                    {{ header }}
                </h3>
            </slot>
            <!-- @slot Header actions  -->
            <slot name="actions"></slot>
        </div>
        <div
            v-if="showBottomBar"
            class="Header__bar"
        >
            <!-- @slot Table Information (mostly used for pagination info-->
            <slot name="info"></slot>
            <!-- @slot Table filters -->
            <slot name="filters"></slot>
        </div>
    </div>
</template>

<script>
import statusBuilder from 'status/statusBuilder';
import stat from 'status';
export default {
    name: "Header",
    props: {
        status: {
            type: String,
            default: stat.STANDBY
        },
        showItems: {
            type: Boolean,
            default: false
        },
        header: {
            type: String,
            default: ''
        },
    },
    computed: {
        showBottomBar(){
            return !!this.$slots.filters || this.showItems;
        }
    },
    methods: {
        statusBuilder,
    }
};
</script>

<style lang="scss">
.Header {
    margin-bottom: 0.5rem;
    &__bar{
        display:flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 1rem;
        &--top{
            padding-bottom: 1rem;
            border-bottom: 1px solid $grey-100;
        }
    }
    &__header{
        @include loading(1.7rem, 25%);
    }
}
</style>